'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getGroupByCompany(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/listbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Group by Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getGroupDetailById(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/detailbygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get Group Detail by Id', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getGroupParentByLevel(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/findparent`
        const result = await axios.get(url, {
          ...costumHeader('Get Group Parent by Level', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getGroupListById(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/listbyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Group List by Id', 4),
          params,
        })
        if (result) if (result.data) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: 'Failed to get data'})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getGroupByHierarchyByCompany(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/viewhierarchybycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Group Hierarchy by Company', 4),
          params,
        })
        if (result) if (result.data) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: 'Failed To Get Data'})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveGroup(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/add`
        const result = await axios.post(url, body, costumHeader('Save Group', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editGroup(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/edit`
        const result = await axios.post(url, body, costumHeader('Edit Group', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteGroup(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/group/delete`
        const result = await axios.post(url, body, costumHeader('Delete Group', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
}

export default { actions }